
import React from 'react';
import { Button } from '@/components/ui/button';

interface HeroProps {
  onGetStarted: () => void;
}

const Hero: React.FC<HeroProps> = ({ onGetStarted }) => {
  return (
    <section className="relative pt-32 pb-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center space-y-6">
          {/* Main Heading */}
          <h1 className="text-4xl md:text-5xl font-bold leading-tight text-gray-900">
            Your Jiu Jitsu Journey, All of It
          </h1>
          
          {/* Subheading */}
          <p className="text-lg md:text-xl text-gray-600 max-w-2xl mx-auto leading-relaxed">
            A home for your progress, your game, and your growth. Log your training, get insights into your game, suck less — all in one place.
          </p>
          
          {/* CTA Button */}
          <div className="pt-4">
            <Button 
              size="lg" 
              className="bg-blue-700 hover:bg-blue-800 text-white text-lg px-8 py-4 rounded-lg font-medium" 
              onClick={onGetStarted}
            >
              Start Free — No Card Needed
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
